/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component } from '@angular/core';
import { EntityFinderDialog, EntityFinderParams, ISortModel, StatusService } from '@core';

import { AccountPurchaseOrder, AccountPurchaseOrderLog } from '@models';

import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { UtilFns } from '@utils';

export interface AccountPurchaseOrderLogFinderParams extends EntityFinderParams {
  accountPurchaseOrderLogs: AccountPurchaseOrderLog[];
}

@Component({
  selector: 'prox-puchase-order-log-finder',
  template: EntityFinderDialog.HTML,
  standalone: false,
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class AccountPurchaseOrderLogFinderDialog extends EntityFinderDialog<AccountPurchaseOrderLog, AccountPurchaseOrderLogFinderParams> {
  params!: AccountPurchaseOrderLogFinderParams;

  constructor(
    ref: DynamicDialogRef,
    override config: DynamicDialogConfig<AccountPurchaseOrderLogFinderParams>,

    private statusService: StatusService,
  ) {
    super(ref, config);
    UtilFns.assertNonNull(config.data);
    this.params = config.data;
  }

  override async initialize() {
    return {
      header: 'Viewing Purchase Order Logs',
      width: 'calc(40vw)',
    };
  }

  override async initDatasource() {
    return this.params.accountPurchaseOrderLogs;
  }

  override getColDefsAndSortModel() {
    const colDefs = [
      // { headerName: 'Purchase Order', field: 'purchaseOrder' },

      {
        headerName: 'Log Ts',
        field: 'logTs',
        filter: 'agDateColumnFilter',
      },
      { headerName: 'Amount', field: 'amt', filter: 'agNumberColumnFilter' },
      { headerName: 'Job Order', field: 'jobOrder.displayId', filter: 'agTextColumnFilter' },
      { headerName: 'User', field: 'jobOrder.accountUser.proximityUser.name', filter: 'agTextColumnFilter' },
    ];
    const sortModel = [{ colId: 'logTs', sort: 'desc' }] as ISortModel;
    return [colDefs, sortModel] as const;
  }
}
